export const DatabaseTypeItem = {
    'name': 'dbTypeItem',
    'filter': [() => {
        return (input,dbType) => {
            let result = input[0];
            switch(dbType) {
                case '1':
                    switch(input[0]) {
                        case 'Schemas':
                            result = 'Databases';
                            break;
                        case 'Schema':
                            result = 'Database';
                            break;
                        case 'schemas':
                            result = 'Databases';
                            break;
                        case 'schema':
                            result = 'Database';
                            break;
                        }
                    break;
                case '3':
                    break;
                default:
                    switch(input[0]) {
                        case 'Schemas':
                            result = 'Databases'
                            break;
                        case 'Schema':
                            result = 'Database'
                            break;
                    }
            }
            return result;
        }
    }]
};



// WEBPACK FOOTER //
// ./src/app/common/pipes/dbTypeItem.js